module.exports = "<div ui-view=main id=mainview></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shifts/shift.html
// module id = 487
// module chunks = 0